import type { ReactNode } from 'react';
import React, { Children, useEffect, useRef } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import type { LayerHeaderButtonProps } from './layer-header-button/LayerHeaderButton';
import { LayerHeaderButton } from './layer-header-button/LayerHeaderButton';
import { themes } from './LayerHeader.themes';
type LayerHeaderProps = {
  buttonLeft?: LayerHeaderButtonProps | null | undefined;
  buttonRight?: LayerHeaderButtonProps | null | undefined;
  children?: ReactNode;
  className?: string;
  closeLabel?: string;
  hasContainer?: boolean;
  height: number;
  onClose?: (e?: React.SyntheticEvent) => void;
  theme?: keyof typeof themes;
};
export const LayerHeader = ({
  buttonLeft,
  buttonRight,
  children,
  className,
  closeLabel,
  hasContainer,
  height,
  onClose,
  theme = 'default',
}: LayerHeaderProps) => {
  const layerButtonRef = useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);
  const { thChild, thClose, thCloseIconWidth, thCloseLabel, thInner, thRoot } = themes[theme];
  return (
    <header
      className={classnames(thRoot, className)}
      style={{
        height,
        maxHeight: height,
      }}
    >
      <div
        className={classnames(thInner, {
          'm-auto w-full max-w-site': hasContainer,
        })}
        data-testid="LayerHeader-body"
      >
        <button
          className={thClose}
          data-testid="Layer-close"
          onClick={onClose}
          ref={layerButtonRef}
          type="button"
        >
          {!!closeLabel && <span className={thCloseLabel}>{closeLabel}</span>}
          <Icon name={ICONS.CROSS} width={thCloseIconWidth} />
        </button>
        {/* @ts-expect-error TODO(flow-migration) */}
        <LayerHeaderButton dataTestId="layer-header-button-left" {...buttonLeft} theme={theme} />
        {!!Children.count(children) && <div className={thChild}>{children}</div>}
        {/* @ts-expect-error TODO(flow-migration) */}
        <LayerHeaderButton dataTestId="layer-header-button-right" {...buttonRight} theme={theme} />
      </div>
    </header>
  );
};
